import { isFirstWorkIncomplete } from "@/components/model/user/_function/firstWorkGift";
import { getJstDateKey } from "@/components/model/user/_function/workReward";

/** 要件定義の首都圏4都県（サーバー PREFECTURES_IN_KANTO とは範囲が異なる） */
export const PREFECTURES_IN_TOKYO_METROPOLITAN_AREA = [
  "東京都",
  "神奈川県",
  "埼玉県",
  "千葉県",
] as const;

export const WORK_INTENTION_SURVEY_DISPLAY_START_JST_DATE = "2026-06-24";
export const WORK_INTENTION_SURVEY_DISPLAY_END_JST_DATE = "2026-06-30";

export type NotificationDataForWorkIntentionSurvey = {
  viewer: {
    id: string;
    status: string;
    isSuspended: boolean;
    isIdentification: boolean;
    hasProfile: boolean;
    hasAddress: boolean;
  } | null;
  address: {
    prefecture: string;
  } | null;
  usageStatus: {
    workedCount: number;
  } | null;
};

export function isWithinWorkIntentionSurveyDisplayPeriod(
  now: Date = new Date(),
): boolean {
  const jstDateKey = getJstDateKey(now);
  return (
    jstDateKey >= WORK_INTENTION_SURVEY_DISPLAY_START_JST_DATE &&
    jstDateKey <= WORK_INTENTION_SURVEY_DISPLAY_END_JST_DATE
  );
}

export function isInTokyoMetropolitanArea(
  prefecture: string | null | undefined,
): boolean {
  if (!prefecture) return false;
  return (PREFECTURES_IN_TOKYO_METROPOLITAN_AREA as readonly string[]).includes(
    prefecture,
  );
}

export function isEligibleForWorkIntentionSurvey(
  data: NotificationDataForWorkIntentionSurvey | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!data?.viewer || data.usageStatus == null || !data.address?.prefecture) {
    return false;
  }

  const { viewer, address, usageStatus } = data;

  if (!isWithinWorkIntentionSurveyDisplayPeriod(now)) return false;
  if (viewer.status !== "enabled") return false;
  if (viewer.isSuspended) return false;
  if (!viewer.hasProfile || !viewer.hasAddress || !viewer.isIdentification) {
    return false;
  }
  if (!isFirstWorkIncomplete(usageStatus.workedCount)) return false;
  if (!isInTokyoMetropolitanArea(address.prefecture)) return false;

  return true;
}
